import {
  VuexModule,
  Module,
  Mutation,
  getModule,
} from 'vuex-module-decorators';
import { Location } from 'vue-router';

import store from '@/store';

export interface IBreadCrumb {
  text: string;
  disabled: boolean;
  href?: string;
}

export interface IBreadCrumbs {
  back: boolean;
  path: IBreadCrumb[];
}

export interface IBreadCrumbsState {
  breadCrumbs: IBreadCrumbs | null;
  backLocation: Location | null;
}

@Module({ dynamic: true, store, name: 'breadCrumbsModule', namespaced: true })
class BreadCrumbs extends VuexModule implements IBreadCrumbsState {
  breadCrumbs: IBreadCrumbs | null = null;
  backLocation: Location | null = null;

  @Mutation
  public SET(payload: IBreadCrumbs | null) {
    this.breadCrumbs = payload;
  }

  @Mutation
  public setBackLocation(payload: Location | null) {
    this.backLocation = payload;
  }
}

export const BreadCrumbsModule = getModule(BreadCrumbs);
